"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var formatters = require("./formatters");
var debug = require("debug")("knack.formatter.value-formatter");
var _ = require("lodash");

/**
 * @alias "valueFormatter.formatValue"
 * @param {Object} field Field context
 * @param {String} field.type Field type
 * @param {Object} [field.format]
 * @param {String} [field.thumb_key] Thumb key for image field
 * @param {Any} value Value to be formatted
 * @param {Object} responseFormat Format to pass into formatter
 * @param {Object} options Options to pass into formatter
 */
var formatValue = function formatValue(_ref, value, responseFormat, options) {
  var fieldType = _ref.type,
    fieldFormat = _ref.format,
    thumbKey = _ref.thumb_key;
  if (_typeof(value) === "undefined") {
    return "";
  }
  if (!fieldType) {
    return "";
  }
  var formatted;
  var child;
  switch (fieldType) {
    case "address":
      formatted = formatters[fieldType](value, fieldFormat, responseFormat);
      break;
    case "boolean":
      formatted = formatters[fieldType](value, fieldFormat, options);
      break;
    case "paragraph_text":
    case "concatenation":
      formatted = formatters.string(value);
      break;
    case "name":
      formatted = formatters[fieldType](value, fieldFormat);
      break;
    case "currency":
      formatted = formatters[fieldType](value, fieldFormat);
      break;
    case "number":
    case "count":
      formatted = formatters.number(value, fieldFormat);
      break;
    case "rating":
      formatted = formatters.number(value, {
        precision: 2
      });
      break;
    case "signature":
      formatted = formatters[fieldType](value);
      break;
    case "multiple_choice":
      formatted = formatters.multipleChoice(value, fieldFormat);
      break;
    case "connection":
      formatted = formatters[fieldType](value, fieldFormat, responseFormat);
      break;
    case "date_time":
      formatted = formatters.date(value, fieldFormat);
      break;
    case "timer":
      formatted = formatters[fieldType](value, fieldFormat, responseFormat);
      break;
    case "email":
      formatted = formatters[fieldType](value, fieldFormat, responseFormat);
      break;
    case "file":
      formatted = formatters[fieldType](value, fieldFormat, options);
      break;
    case "image":
      formatted = formatters[fieldType](value, thumbKey, options);
      break;
    case "link":
      formatted = formatters[fieldType](value, fieldFormat, responseFormat);
      break;
    case "phone":
      formatted = formatters[fieldType](value, fieldFormat, responseFormat, options);
      break;
    case "password":
      formatted = "*********";
      break;
    case "min":
    case "max":
    case "average":
    case "sum":
      if (_.hasIn(fieldFormat, "field.key")) {
        child = options.application.getField(fieldFormat.field.key);
      }
      if (child && child.type && child.type === "currency") {
        formatted = formatters.currency(value, child.format);
      } else if (child && child.type && child.type === "date_time") {
        formatted = formatters.date(value, child.format);
      } else if (child && child.type && child.type === "equation") {
        // date equation...like finding the max date
        if (child.format && child.format.equation_type && child.format.equation_type === "date" && child.format.date_result && child.format.date_result === "date") {
          formatted = formatters.equation(value, child.format);
        } else {
          formatted = formatters.number(value, fieldFormat);
        }
      } else if (child && child.type && child.type === "timer") {
        var childFormat = _.clone(child.format);
        if (fieldFormat.format) {
          format.total_format = fieldFormat.format;
        }
        formatted = formatters.timer({
          total_time: value
        }, childFormat, childFormat);
        if (format.total_format !== "from-to") {
          var clonedFieldFormat = _.clone(fieldFormat);
          delete clonedFieldFormat.format;
          formatted = formatters.number(formatted, clonedFieldFormat);
        }
      } else {
        formatted = formatters.number(value, fieldFormat);
      }
      break;
    case "equation":
      formatted = formatters[fieldType](value, fieldFormat);
      break;
    case "user_roles":
      formatted = formatters.profile(value, fieldFormat, "html", options);
      break;
    default:
      formatted = value;
      break;
  }
  return formatted;
};
module.exports = {
  formatValue: formatValue
};